import React from "react";
import { Route, Routes } from "react-router-dom";
import Roles from "../inner_pages/roles/Roles";
import User from "../inner_pages/user/User";
import Method_of_Testing from "../inner_pages/Method_of_testing/Parent";
import Customer_type from "../inner_pages/customer_type/Parent";
import PrefferedCommunicationMode from "../inner_pages/preffedcommunicationmode/Parent";
import Parameters from "../inner_pages/parameters/Parent";
import Material_Tested from "../inner_pages/material_tested/Parent";
import Test_Method from "../inner_pages/test_method/Parent";
import Component from "../inner_pages/component/Parent";
import Test_Type from "../inner_pages/test_type/Parent";
import Relevant_Training from "../inner_pages/relevant_training/Parent";
import Designation from "../inner_pages/designation/Parent";
import Qualification from "../inner_pages/qualification/Parent";
import Specialization from "../inner_pages/specialization/Parent";
import Country from "../inner_pages/country/Parent";
import State from "../inner_pages/state/Parent";
import City from "../inner_pages/city/Parent";
import RoomType from "../inner_pages/roomtype/Parent";
import ServiceUsed from "../inner_pages/serviceused/Parent";
import VerificationType from "../inner_pages/verificationtype/Parent";
import TestedBy from "../inner_pages/testedby/Parent";
import NatureByComplaint from "../inner_pages/nature_of_complaint/Parent";
import Department from "../inner_pages/department/Parent";

import TraingField from "../inner_pages/training_field/Parent";

import TrainingType from "../inner_pages/training_type/Parent";

import PaymentMethod from "../inner_pages/payment_method/Parent";
import MaintenanceStatus from "../inner_pages/maintenance_status/Parent";
import NoAccess from "../../../NoAccess/noaccess";
import { ProtectedRoute } from "../../../../utils/common"; // adjust path
import { FixIDS } from "../../../../utils/fixIDS";
import { useSelector } from "react-redux";

const User_Management_Routes = () => {
  const permissions = useSelector((state) => state.auth.permissions);

  // 🔹 if permissions not loaded, return nothing or loader
  if (!permissions) return <div>Loading...</div>;

  return (
    <Routes>
      <Route path="/roles" element={<Roles />} />
      <Route path="/user" element={<User />} />

      <Route path="/methodoftesting" element={<Method_of_Testing />} />

      <Route path="/customertype" element={<Customer_type />} />

      <Route
        path="/prefferedcommunicationmode"
        element={<PrefferedCommunicationMode />}
      />

      <Route path="/parameters" element={<Parameters />} />

      <Route path="/material_tested" element={<Material_Tested />} />

      <Route path="/test_method" element={<Test_Method />} />

      <Route path="/component" element={<Component />} />

      <Route path="/test_type" element={<Test_Type />} />

      <Route path="/relevant_training" element={<Relevant_Training />} />

      <Route path="/designation" element={<Designation />} />

      <Route path="/qualification" element={<Qualification />} />

      <Route path="/specialization" element={<Specialization />} />

      <Route path="/country" element={<Country />} />

      <Route path="/state" element={<State />} />

      <Route path="/city" element={<City />} />

      <Route path="/roomtype" element={<RoomType />} />

      <Route path="/serviceused" element={<ServiceUsed />} />

      <Route path="/type_of_verification" element={<VerificationType />} />

      <Route path="/tested_by" element={<TestedBy />} />

      <Route path="/nature_of_complaint" element={<NatureByComplaint />} />

      <Route path="/department" element={<Department />} />
      <Route path="/training-type" element={<TrainingType />} />
      <Route path="/training-field" element={<TraingField />} />

      <Route path="/payment-method" element={<PaymentMethod />} />
      <Route path="/maintenance-status" element={<MaintenanceStatus />} />

      {/* <Route path="/no-access" element={<NoAccess />} /> */}
    </Routes>
  );
};

export default User_Management_Routes;
